module.exports = __webpack_public_path__ + "img/1.11afa4d8.png";